<template>
    <div class="chat-message streaming-display">
        <span v-html="message"></span>
        <typing-indicator></typing-indicator>
    </div>
</template>
<script>
import TypingIndicator from '@/components/TypingIndicator';
import utils from '@/utils';
export default {
    name: 'Streaming_message',
    data() {
        return {
        }
    },
    components: {
        TypingIndicator
    },
    updated() {
        setTimeout(() => {
            utils.scrollDown();
        }, 100);
    },
    mounted() {
        utils.scrollDown()
    },  
    props: {
        message: {
            type: String,
            required: true,
            default: ''
        },
    }
}
</script>